import { put, call } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { OK } from '../../../configs/serverStatusCodes';
import {
  loadLostTicketListFailed,
  loadLostTicketListSuccessful,
  loadLostTicketListBegin,
} from '../actions';

export default function* loadLostTicketList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = 5,
      page = 1,
      all = true,
    } = payload;
    const pool = {
      limit,
      page,
      all,
    };

    const url = `${BACKEND_URL}/proxy/tariff/v1/lost-tickets`;
    yield put(loadLostTicketListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      data.result = data.data;
      yield put(loadLostTicketListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadLostTicketListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadLostTicketListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
